import { connect } from 'react-redux';
import { hasHubspotProjectPermissions } from './index';


function WithHasHubspotPermissions({ children, currentProject, currentUser }) {
  if (hasHubspotProjectPermissions(currentProject, currentUser)) {
    return children;
  } else {
    return null;
  }
}

const mapStateToProps = (state) => {
  return {
    currentProject: state.app.currentProject,
    currentUser: state.app.user,
  };
};

export default connect(mapStateToProps)(WithHasHubspotPermissions);



// WEBPACK FOOTER //
// ./src/components/Permissions/WithHubspotProjectPermissions.js